import React from 'react'
import './loadingProductView.css'

function LoadingProductView() {
  return (
    <div className='product loading_product_item-view'></div>
  )
}

export default LoadingProductView